export default class AppTool {

  static openLoadingDialog(dialogItem) {
    //alert(dialogItem)
    if (dialogItem == '') {
      return;
    }
    const dialogItems = document.querySelectorAll(dialogItem);
    dialogItems.forEach(function (item) {
      item.style.display = 'flex';
    });

    setTimeout(function () {
      dialogItems.forEach(function (item) {
        var cDialog = item.querySelector('.cDialog');
        const cMask = item.querySelector('.cMask');
        if (cDialog) {
          cDialog.style.opacity = '1';
        }
        if (cMask) {
          cMask.style.opacity = '1';
        }
      });
    }, 100);
  }

  static closeLoadingDialog(dialogItem) {
    if (dialogItem == '') {
      return;
    }
    const dialogItems = document.querySelectorAll(dialogItem);
    dialogItems.forEach(function (item) {
      const cDialog = item.querySelector('.cDialog');
      const cMask = item.querySelector('.cMask');
      if (cDialog) {
        cDialog.style.opacity = '0';
        setTimeout(function () {
          item.style.display = 'none';
        }, 500);
      }
      if (cMask) {
        cMask.style.opacity = '0';
      }
    });
  }

  static openDialog(dialogItem) {
    //alert(dialogItem)
    if (dialogItem == '') {
      return;
    }
    const dialogItems = document.querySelectorAll(dialogItem);
    dialogItems.forEach(function (item) {
      item.style.display = 'flex';
    });

    setTimeout(function () {
      dialogItems.forEach(function (item) {
        var cDialog = item.querySelector('.cDialog');
        if (cDialog) {
          cDialog.style.transform = 'scale(1)';
        }
      });
    }, 100);
  }

  static closeDialog(dialogItem) {
    if (dialogItem == '') {
      return;
    }
    const dialogItems = document.querySelectorAll(dialogItem);
    dialogItems.forEach(function (item) {
      const cDialog = item.querySelector('.cDialog');
      if (cDialog) {
        cDialog.style.transform = 'scale(0)';
        setTimeout(function () {
          item.style.display = 'none';
        }, 500);
      }
    });
  }
}